import React, { useContext, createContext, useState, useRef } from 'react';

export const ScrollCacheContext = createContext();

// this is shared across all calls to "useScrollCache"
// changes to the cache are propagated to all consumers of useScrollCache
export const ScrollCacheProvider = ({ children }) => {
  // the cache, the bucket where we put data, and a function to set a new value
  const [cache, setCache] = useState({
    top: 0,
  });

  // this is a reference to an element
  // we will use this to know the element to track for scrolling,
  // and to manually scroll to recover position
  const manuallyScrollToElementRef = useRef();

  // when this is called,
  const scrollToSavedCache = () => {
    if (!manuallyScrollToElementRef.current) {
      return;
    }
    manuallyScrollToElementRef.current.scrollTo({
      top: cache.top,
      left: 0,
      behavior: 'instant',
    });
  };

  // this is called on scroll events,
  // we get the current scrolled position of the delement where this runs
  const saveCurrentPositionToCache = (event) => {
    setCache({ top: event.currentTarget.scrollTop });
  };

  const resetScrollCache = () => {
    setCache({ top: 0 });
  };

  // we expose this
  const scrollCache = {
    // the ref to attach one div for scroll tracking
    manuallyScrollToElementRef,
    // we will call this when we want to scroll to the last cached position
    scrollToSavedCache,
    // on scroll, we save current position to cache
    saveCurrentPositionToCache,
    //
    resetScrollCache,
    // we could expose the cache if we needed to show or do something
    // cache,
  };

  return (
    <ScrollCacheContext.Provider value={scrollCache}>
      {children}
    </ScrollCacheContext.Provider>
  );
};

const useScrollCache = () => {
  return useContext(ScrollCacheContext);
};

export default useScrollCache;
